<template>
  <v-hover v-slot="{ hover }">
    <v-row
      align="center"
      class="pa-0 ma-0"
      :class="hover ? 'green lighten-5' : ''"
    >
      <v-col cols="2" class="">
        <v-icon
          v-if="therm.isBlocked || therm.alarmpoint >= therm.temp_now"
          size="20"
          color="red"
          class="mr-2 mb-1"
          >mdi-alert</v-icon
        >
        <v-icon
          v-else-if="therm.probeError"
          size="20"
          class="mr-2 mb-1"
          color="amber"
          >mdi-alert-box</v-icon
        >
        <v-icon
          v-else
          size="20"
          class="mr-2 mb-1"
          :color="therm.isConnected ? 'green' : 'grey'"
          >mdi-circle</v-icon
        >
        <span
          style="font-size: 16px"
          :class="{
            'grey--text text--lighten-1': !therm.isConnected,
            'red--text': therm.isBlocked || therm.alarmpoint >= therm.temp_now,
            'amber--text': therm.probeError,
          }"
          >{{ therm.nome }}</span
        >
        <v-icon
          v-if="therm.isConnected && therm.isBurning && !therm.isBlocked"
          color="orange"
          class="ml-2 mb-1"
          >mdi-fire</v-icon
        >

        <template v-if="!therm.isConnected">
          <span class="grey--text text--lighten-1 ml-2">(Disconnesso)</span>
        </template>
        <template v-else>
          <span v-if="therm.isBlocked" class="red--text text--lighten-1 ml-2"
            >(Blocco Bruciatore)</span
          >
          <span
            v-else-if="therm.probeError"
            class="amber--text text--lighten-1 ml-2"
            >(Errore Sonda)</span
          >
          <span
            v-else-if="therm.alarmpoint >= therm.temp_now"
            class="red--text text--lighten-1 ml-2"
            >(Allarme Temp.)</span
          >
        </template>
      </v-col>
      <v-col cols="1" class="d-flex align-center">
        <v-icon class="" :color="therm.isConnected ? 'green' : 'grey'"
          >mdi-thermometer</v-icon
        >
        <span
          style="font-size: 20px; font-weight: 300"
          class="ml-2"
          :class="
            therm.isConnected && !therm.probeError ? tempColor + '--text' : ''
          "
          >{{
            therm.isConnected && !therm.probeError
              ? therm.temp_now.toFixed(1) + " °C"
              : "N/A"
          }}</span
        >
      </v-col>
      <v-col cols="1">
        <v-icon class="mr-2" :color="therm.isConnected ? 'red' : 'grey'"
          >mdi-menu-up</v-icon
        >
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <span v-on="on" v-bind="attrs">{{
              therm.isConnected ? max_temp + " °C" : "N/A"
            }}</span>
          </template>
          <span>{{ max_date }}</span>
        </v-tooltip>
      </v-col>
      <v-col cols="1">
        <v-icon class="mr-2" :color="therm.isConnected ? 'blue' : 'grey'"
          >mdi-menu-down</v-icon
        >
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <span v-on="on" v-bind="attrs">{{
              therm.isConnected ? min_temp + " °C" : "N/A"
            }}</span>
          </template>
          <span>{{ min_date }}</span>
        </v-tooltip>
      </v-col>
      <v-col cols="1">
        <v-icon class="mr-2" :color="therm.isConnected ? 'orange' : 'grey'"
          >mdi-menu-right</v-icon
        >
        <span>{{ therm.isConnected ? avg_temp + " °C" : "N/A" }}</span>
      </v-col>
      <v-col cols="1">
        <v-icon
          class="mr-2"
          :color="therm.isConnected ? 'purple' : 'grey'"
          size="20"
          >mdi-clock-outline</v-icon
        >
        <span>{{ burning_time }} </span>
      </v-col>
      <v-col cols="1">
        <v-icon class="mr-2" :color="therm.isConnected ? 'teal' : 'grey'"
          >mdi-water</v-icon
        >
        <span>{{ therm.isConnected ? litri + " lit." : "N/A" }}</span>
      </v-col>
      <v-col cols="1">
        <v-icon class="mr-2" :color="therm.isConnected ? 'blue' : 'grey'"
          >mdi-thermostat-box</v-icon
        >
        <span>{{ therm.setpoint.toFixed(1) }} °C</span>
      </v-col>
      <v-col cols="1">
        <v-icon
          v-if="therm.phoneEnabled"
          class="mr-2"
          :color="therm.isConnected ? 'green' : 'grey'"
          >mdi-phone</v-icon
        >
        <v-icon
          v-else
          class="mr-2"
          :color="therm.isConnected ? 'green' : 'grey'"
          >mdi-phone-off</v-icon
        >
        <v-icon
          v-if="therm.pushEnabled"
          class="mr-2"
          :color="therm.isConnected ? 'amber' : 'grey'"
          >mdi-bell-ring</v-icon
        >
        <v-icon
          v-else
          class="mr-2"
          :color="therm.isConnected ? 'amber' : 'grey'"
          >mdi-bell-off</v-icon
        >
        <span>{{ therm.alarmpoint.toFixed(1) }} °C</span>
      </v-col>
      <v-col cols="2" class="d-flex justify-end">
        <v-btn icon color="grey" @click="$refs.setpointBox.open()" class="mr-8">
          <v-icon>mdi-wrench</v-icon>
        </v-btn>
        <v-btn icon color="purple" @click="$refs.chartBox.open()" class="mr-2">
          <v-icon>mdi-chart-line</v-icon>
        </v-btn>
        <ChartBox :therm="therm" ref="chartBox" />
        <v-btn icon color="blue" @click="$refs.infoBox.open()" class="">
          <v-icon>mdi-information-variant</v-icon>
        </v-btn>
        <v-btn icon color="grey" class="ml-8" @click="$refs.editBox.open()">
          <v-icon>mdi-cog</v-icon>
        </v-btn>
      </v-col>
      <SetPointBox :therm="therm" ref="setpointBox" />
      <InfoBox :therm="therm" ref="infoBox" />
      <EditBox :therm="therm" ref="editBox" />
    </v-row>
  </v-hover>
</template>

<script>
import thermElementMixin from "@/components/Tanks/mixin/therm_element_mixin";
import SetPointBox from "./set_point_box.vue";
import InfoBox from "./therm_info_box.vue";
import ChartBox from "./therm_chart_box.vue";
import EditBox from "./therm_edit_box.vue";

export default {
  mixins: [thermElementMixin],
  components: {
    SetPointBox,
    ChartBox,
    InfoBox,
    EditBox,
  },
};
</script>